<template>
  <div class="print-section">
    <h2 class="print-heading">今すぐお手元に。近くの印刷スポットを確認</h2>
    <div class="print-map-area">
      <div
        v-show="session.showMap"
        ref="konbiniMap"
        class="print-map-img"
        style="height: 250px"
      ></div>
      <img
        v-show="!session.showMap"
        src="https://placehold.jp/24/cccccc/ffffff/400x250.png?text=Map+Image"
        alt="Map"
        class="print-map-img"
      />
      <button
        type="button"
        class="print-map-btn"
        aria-label="現在地"
        :disabled="session.isGeolocating"
        @click="actions.recenterToCurrentLocation"
      >
        <span class="print-map-btn-icon"></span>
      </button>
    </div>
    <p v-if="session.mapError" class="konbini-map-error">
      {{ session.mapError }}
    </p>
    <div class="print-action-group">
      <a
        href="#"
        class="print-btn print-btn--large"
        @click.prevent="actions.openMapAppNearCurrentLocation"
      >
        <span class="print-btn-text">{{
          session.isGeolocating
            ? '位置情報を取得中...'
            : '現在地周辺のコンビニをマップアプリで確認'
        }}</span>
        <span class="print-btn-icon-wrapper">
          <img
            src="/static/img/eprint/map-icon.svg"
            class="print-btn-icon-inner"
          />
        </span>
      </a>
      <a
        v-if="session.resumeAddress"
        href="#"
        class="print-btn print-btn--small"
        @click.prevent="actions.openMapAppNearResumeAddress"
      >
        <span class="print-btn-text">{{
          session.isGeocodingAddress
            ? '住所を検索中...'
            : '履歴書の住所周辺のコンビニを探す'
        }}</span>
        <span class="print-btn-icon-wrapper">
          <img
            src="/static/img/eprint/map-icon.svg"
            class="print-btn-icon-inner"
          />
        </span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'

const session = useEprintSession()
const actions = useEprintActions()
const konbiniMap = ref<HTMLElement | null>(null)

onMounted(() => {
  actions.bindMapEl(konbiniMap.value)
})
watch(konbiniMap, (el) => {
  actions.bindMapEl(el)
})
onBeforeUnmount(() => {
  actions.bindMapEl(null)
})
</script>
